import { DTO } from './database';

const collection = 'services';
export const servicesModel = new DTO(collection);
